export default __webpack_public_path__ + "static/media/instagram.d91d8116.svg";